import * as React from "react";
function SvgTransmitter(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M6.1 31.4c-8.4-8.8-8-22.8.7-31.1l2 2c-7.7 7.3-8 19.4-.7 27.1l-2 2zm35.9 0l-2.1-2c7.3-7.7 7-19.8-.7-27.1l2-2.1c8.7 8.4 9.2 22.4.8 31.2zm-29-5c-5.7-6-5.4-15.4.6-21.1l2 2c-4.8 4.6-5 12.2-.4 17.1l-2.2 2zm22.5 0l-2.1-2c4.6-4.8 4.4-12.5-.4-17.1l2-2c6 5.7 6.1 15.1.5 21.1zM30.3 16c.1-3.1-2.4-5.7-5.6-5.8-1.6 0-3 .6-4.1 1.6-1.1 1-1.7 2.4-1.7 4-.1 1.4.3 3 1.3 4.1.7.7 2.3 1.3 2.3 1.6v24.9c0 .9.6 1.4 1.4 1.4s1.4-.6 1.4-1.4v-25c1.1-.1 2.1-.6 2.8-1.4 1.3-1.1 2-2.4 2.2-4zm-4 1.6c-1 1-2.6.9-3.4 0-.4-.4-.7-1.1-.7-1.7 0-1.3 1-2.3 2.3-2.3h.1c.6 0 1.3.3 1.7.7 1 .9 1 2.3 0 3.3z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTransmitter);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
